import { Injectable } from '@angular/core';

import { RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PlannerStopsState } from '../../schedule.model';
import { ScheduleService } from '../../schedule.service';
import { PlannerActions } from './planner.action';

@Injectable()
export class PlannerEpics implements RidangoEpic {
    constructor(private actions: PlannerActions, private service: ScheduleService) {}

    register() {
        return [this.fetchOriginList, this.fetchDestinationList, this.fetchTrip];
    }

    fetchOriginList = (action$: ActionsObservable<any>) =>
        action$.ofType(PlannerActions.FETCH_ORIGIN_LIST).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchStopList(action.payload).pipe(
                    map((response) => this.actions.fetchOriginListSuccess(this.normalizeStopList(response))),
                    catchError(() => of(this.actions.fetchOriginListFail()))
                );
            })
        )

    fetchDestinationList = (action$: ActionsObservable<any>) =>
        action$.ofType(PlannerActions.FETCH_DESTINATION_LIST).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchStopList(action.payload).pipe(
                    map((response) => this.actions.fetchDestinationListSuccess(this.normalizeStopList(response))),
                    catchError(() => of(this.actions.fetchDestinationListFail()))
                );
            })
        )

    private normalizeStopList(response) {
        const stops: PlannerStopsState = {
            ids: [],
            byId: {},
            all: [],
        };

        response['stopLocationOrCoordLocation'].forEach((d) => {
            if (d['StopLocation']) {
                stops.ids.push(d['StopLocation'].extId);
                stops.byId[d['StopLocation'].extId] = d['StopLocation'];
                stops.all.push(d['StopLocation']);
            }
        });

        return stops;
    }

    fetchTrip = (action$: ActionsObservable<any>) =>
        action$.ofType(PlannerActions.FETCH_TRIP).pipe(
            switchMap((action: RidangoReduxAction) => {
                return this.service.fetchPlannerTrip(action.payload).pipe(
                    map((response) => this.actions.fetchTripSuccess(response['Trip'])),
                    catchError(() => of(this.actions.fetchTripFail()))
                );
            })
        )
}
